import { ReactComponent as Icon } from "./add.svg";

const AddIcon = () => {
    return <Icon />;
}

export default AddIcon;